<template lang="pug">
.hcb-location-search
  .search-wrap
    p.text-center.xs-f-large.bold.brand-color-1.max-at-tweak.mb-10 {{ title }}
    p.sub-title.text-center.xs-f-medium.max-at-tweak.brand-color-1.xs-mb-150m {{ subTitle }}

    form.search-container.hcb-autocomplete-input(name="GmapSearch" @submit.prevent="setZipBySubmit")
      GmvAutocomplete.form-control.xs-f-medium.max-at-tweak(
        ref="autocomplete"
        :value="autocompleteContent.name"
        :options="{ componentRestrictions: { country: 'us' } }"
        @place_changed="onPlaceChanged"
        :placeholder="placeholderText"
        :select-first-on-enter="true"
      )
      button.pull-right.mr-btn.btn-secondary.xs-f-small.max-at-tweak(type="submit") Update

    p.error.sub-text.mt-10.text-center.xs-f-xsmall.max-at-tweak(v-if="noLocationsError")
      i.icon-warning
        span {{noLocationsError}}

    p.sub-text.text-center.mt-10.xs-f-xsmall.max-at-tweak {{pricingMayVary}}

</template>
<script>
  import { utilities } from '@gmap-vue/v3';
  import MrIcon from '@components/MrIcon';
  import { mapState, mapActions } from 'vuex';
  import { getClosestLocationsByLatLong } from '@services/vueColorbarSvc';

  const { googleMapsApiInitializer } = utilities;

  export default {
    name: "HcbLocationSearch",

    components: {
      MrIcon,
    },

    inject: ["getObjProperty"],

    props: {
      initialTitle: {
        type: String,
        default: "Search For A Location Near You",
      },
      initialSubTitle: {
        type: String,
        default: "Enter your ZIP Code to find your local Hair Color Bar.",
      },
      initialPricingMayVary: {
        type: String,
        default: "Pricing and benefits may vary by location",
      },
      initialPlaceholderDesktop: {
        type: String,
        default: "Enter your ZIP Code",
      },
      initialPlaceholderMobile: {
        type: String,
        default: "ZIP Code",
      },
      trackEventPrefix: {
        type: String,
        default: "URM Landing",
      },
    },

    data() {
      return {
        autocompleteContent: {},
        title: this.initialTitle,
        subTitle: this.initialSubTitle,
        pricingMayVary: this.initialPricingMayVary,
        placeholderDesktop: this.initialPlaceholderDesktop,
        placeholderMobile: this.initialPlaceholderMobile,
        noLocationsError: false,
      };
    },

    computed: {
      ...mapState('colorbar', [
        'location',
        'locationLoading',
      ]),

      ...mapState('customer', [
        'cdata'
      ]),

      ...mapState('global', [
        'windowData'
      ]),

      breakpoint() {
        return this.getObjProperty(this, 'windowData.breakpoint');
      },

      isMobile() {
        return this.breakpoint == 'mobile' || this.breakpoint == 'tablet';
      },

      placeholderText() {
        return this.isMobile ? this.placeholderMobile : this.placeholderDesktop;
      },

      customerPostalCode() {
        return this.getObjProperty(this, 'cdata.postalCode') || this.getObjProperty(this, 'cdata.address.post_code') || this.getObjProperty(this, 'location.zip') || '';
      }
    },

    async mounted() {
      googleMapsApiInitializer({
        key: this.$root.MRConfig.googleAutocomplete,
        libraries: 'places,geometry',
        v: '2',
      }, false);

      await this.$gmapApiPromiseLazy();
      this.selectLocation();
    },

    methods: {
      ...mapActions(['notifyError']),

      ...mapActions('modal', [
        'showModal',
        'hideModal'
      ]),

      setUserLocationCookie(value) {
        this.$cookies.set('lastSearchedCustomerHcbLocation', value, 0);
      },

      getUserLocationCookie() {
        return this.$cookies.get('lastSearchedCustomerHcbLocation') || {};
      },

      ...mapActions('colorbar', [
        'loadLocation',
      ]),

      setZipBySubmit() {
        const el = this.$refs.autocomplete.$el.querySelector('input');

        if (el.value == this.autocompleteContent.name) {
          return this.onPlaceChanged(this.autocompleteContent);
        }

        if (!el.value) {
          this.setUserLocationCookie({});
        }

        const keyboardEvent = new KeyboardEvent('keydown', {
          code: 'Enter',
          key: 'Enter',
          charCode: 13,
          keyCode: 13,
          view: window,
          bubbles: true
        });
        return el.dispatchEvent(keyboardEvent);
      },

      onPlaceChanged(place) {
        if (!place) {
          this.noLocationsError = "Please enter a ZIP code.";
          return;
        }
        this.trackMREvent(`${this.trackEventPrefix} - Searched Location`);
        let lat = '';
        let lng = '';

        // If coming from autocomplete 
        if (place.geometry) {
          lat = place.geometry.location.lat();
          lng = place.geometry.location.lng();
        } else if (this.getObjProperty(this, 'cdata.locationContext.latitude') && this.getObjProperty(this, 'cdata.locationContext.longitude')) { // If coming from locationContext
          lat = this.cdata.locationContext.latitude;
          lng = this.cdata.locationContext.longitude;
        }

        let params = {
          latitude: lat,
          longitude: lng,
          isNotMiniBar: true,
          isOpen: true
        };

        getClosestLocationsByLatLong(params).then((res) => {
          if (res.data && res.data.length < 1) {
            this.autocompleteContent = {};

            this.setUserLocationCookie({});

            this.trackMREvent(`${this.trackEventPrefix} - Searched Location None Available`, { searchZip: place.name });
            this.noLocationsError = "We're sorry, there are no Hair Color Bar locations near you";
            return;
          }

          this.noLocationsError = false;
          this.autocompleteContent = place;

          this.setUserLocationCookie({ zip: place.name });

          // limit results to 6 closest locations
          res.data = res.data.splice(0, 6);

          this.showModal({
            component: './HairColorBarMembership/HcbLocationSearchResultModal',
            theme: 'hcb-location-search-result',
            props: {
              searchName: place.name,
              locations: res.data,
              selectLocation: this.selectLocation
            },
          });
        }).catch((err) => {
          this.notifyError(null, err);
        });
      },

      selectLocation(location) {
        let code = '';

        let userCustomZipCode = this.getUserLocationCookie();

        if (!location && userCustomZipCode.code) {
          code = userCustomZipCode.code;

          this.autocompleteContent = {
            name: userCustomZipCode.zip
          };
        } else if (this.getObjProperty(this, 'cdata.lastAppointment.locationCode')) {
          // On mounted, if we have the customer's last appointment
          code = this.cdata.lastAppointment.locationCode;
          if (this.customerPostalCode) {
            this.autocompleteContent = {
              name: this.customerPostalCode
            };
          }
        } else if (!location && this.getObjProperty(this, 'cdata.locationContext.closestColorbar')) {
          // On mounted, if we have the customer's closest colorbar load that location
          code = this.cdata.locationContext.closestColorbar;
          if (this.customerPostalCode) {
            this.autocompleteContent = {
              name: this.customerPostalCode
            };
          }
        } else if (location) {
          code = location.code;
          if (userCustomZipCode.zip) {
            this.setUserLocationCookie({ ...userCustomZipCode, code: code });
          }
        } else {
          return;
        }

        this.title = "Not the right location?";
        this.subTitle = "Update your ZIP Code to find your local Hair Color Bar.";

        this.trackMREvent(`${this.trackEventPrefix} - Selected Location`, { location: code });
        this.loadLocation(code);
        this.hideModal();
      },
    }
  };
</script>

<style lang="stylus">
.hcb-autocomplete-input
  div
    width 100%
    input
      height 3em
      width 100%
      padding-left 0.5em
</style>

<style scoped lang="stylus">
  .hcb-location-search
    .search-wrap
      max-width 1200px
      margin 2em auto
      background-color white

      .search-container
        margin 0.5em auto
        max-width 32em
        height 3em
        align-items center
        display flex
        justify-content center

        .search-input
          height 3em
          width 100%
          padding-left 0.5em

  @media mq-tablet-less
    .hcb-location-search
      .sub-text
        text-align left
        margin 0 0.5
        padding 0 1em
        padding-right 5em

      .search-wrap
        padding 1em

        .search-container
          margin 1em
          width 90%

          .search-input
            height 3em
</style>
